module.exports = __webpack_public_path__ + "static/2-ed11aaa2dde776636983e2e1612243c9.jpg";